var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGallery = function SvgIconGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.661 31.604v-9.6c0-.88-.72-1.6-1.6-1.6h-9.6c-.88 0-1.6.72-1.6 1.6v9.6c0 .88.72 1.6 1.6 1.6h9.6c.88 0 1.6-.72 1.6-1.6m-8.8-3.2 1.624 2.168 2.376-2.968 3.2 4h-9.6zm-7.2-4.8v11.2c0 .88.72 1.6 1.6 1.6h11.2v-1.6h-11.2v-11.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 1.661,
    y: 1.404,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 27
  })));
};
export { SvgIconGallery as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA1NyA1NyI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMzYuNjYxIDMxLjYwNHYtOS42YzAtLjg4LS43Mi0xLjYtMS42LTEuNmgtOS42Yy0uODggMC0xLjYuNzItMS42IDEuNnY5LjZjMCAuODguNzIgMS42IDEuNiAxLjZoOS42Yy44OCAwIDEuNi0uNzIgMS42LTEuNlptLTguOC0zLjIgMS42MjQgMi4xNjggMi4zNzYtMi45NjggMy4yIDRoLTkuNmwyLjQtMy4yWm0tNy4yLTQuOHYxMS4yYzAgLjg4LjcyIDEuNiAxLjYgMS42aDExLjJ2LTEuNmgtMTEuMnYtMTEuMmgtMS42WiIvPjxyZWN0IHdpZHRoPSI1NCIgaGVpZ2h0PSI1NCIgeD0iMS42NjEiIHk9IjEuNDA0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiByeD0iMjciLz48L3N2Zz4=";